import React from "react";

export default function Credit() {
  return (
    <div class="credit">
    <p>
      Coded by
      <a href="https://shikhar302001.github.io/Portfolio/"
        > Shikhar Mishra</a
      >, <a href="https://github.com/Shikhar302001/Weather-App">Open sourced on Github.</a> Hosted on Github
    </p>
  </div>
  );
}